
import Vue from 'vue';
import OrganizationService, { Widget } from '~/services/OrganizationService';

export default Vue.extend({
    name: 'WidgetModule',
    props: {
        widgets: {
            type: Array as () => Widget[],
            default: () => [],
        },
        grid: Boolean,
        disableFetch: Boolean,
    },
    data() {
        return {
            widgetList: [] as Widget[],
            service: undefined as OrganizationService | undefined,
        };
    },
    created() {
        if (this.widgets && this.widgets.length > 0) {
            this.widgetList = this.widgets;
            return;
        }

        const w = this.$store.getters['widgetModule/getAllWidgets']();
        if (w && w.length > 0) {
            this.widgetList = w;
            return;
        }

        if (!this.disableFetch) {
            this.service = new OrganizationService();
            this.service
                .getWidgets(true)
                .then(widgets => {
                    // Order system widgets at the bottom
                    this.widgetList = widgets.sort((a, b) => {
                        if (a.isSystemWidget != b.isSystemWidget) {
                            return a.isSystemWidget ? 1 : -1;
                        }
                        return a.order - b.order;
                    });
                })
                .catch((reason: any) => console.error(reason))
                .finally();
        }
    },
    computed: {
        sortedWidgets(): Widget[] {
            const list = [...this.widgetList];
            return list.sort((a, b) => {
                // Order system widgets at the bottom
                if (a.isSystemWidget != b.isSystemWidget) {
                    return a.isSystemWidget ? 1 : -1;
                }
                return a.order - b.order;
            });
        },
    },
    methods: {
        hasLinkWithoutButton(widget: Widget) {
            return !!widget.link && !widget.buttonText;
        },
        showFooter(widget: Widget) {
            return !!widget.buttonText || !!widget.title;
        },
        containerRole(widget: Widget) {
            return this.hasLinkWithoutButton(widget) ? 'link' : null;
        },

        handleContainerClick(widget: Widget) {
            this.hasLinkWithoutButton(widget) && this.handleButtonClick(widget);
        },
        handleButtonClick(widget: Widget) {
            if (widget.link) window.open(widget.link, '_blank', 'noopener noreferrer');
        },
    },
});
